<template>
    <div>
        <h3 class="text-white m-5 text-center"><i>{{this.text ? this.text : $t('sito_manutenzione')}}</i></h3>
    </div>
</template>

<script>

    export default {
        props: ['text']
    }
</script>
